module.exports = __webpack_public_path__ + "img/customer-center-call-normal.5603dbc5.svg";